// extracted by mini-css-extract-plugin
module.exports = {"logos_banner":"styles_logos_banner__6GgZ_","logos":"styles_logos__Gad00"};